import React from "react";
import { Check, Circle, Loader2 } from "lucide-react";

export function TrackingTimeline({ steps, currentStep }) {
  return (
    <div className="space-y-0" data-testid="tracking-timeline">
      {steps.map((step, i) => {
        const done = step.done;
        const active = i === currentStep + 1 && !done && currentStep >= 0;
        const isLastDone = i === currentStep;
        return (
          <div key={i} className="flex gap-4">
            <div className="flex flex-col items-center">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 transition-colors
                ${done ? "bg-[#2D7A5D] text-white" : active ? "bg-[#306D29] text-white" : "bg-[#E7E1B1] text-[#5C5C5C]"}`}>
                {done ? <Check size={16} /> : active ? <Loader2 size={16} className="animate-spin" /> : <Circle size={10} />}
              </div>
              {i < steps.length - 1 && (
                <div className={`w-0.5 flex-1 min-h-[36px] ${done ? "bg-[#2D7A5D]" : "bg-black/10"}`} />
              )}
            </div>
            <div className={`pb-8 ${done || active ? "" : "opacity-50"}`}>
              <p className={`font-semibold ${isLastDone ? "text-[#2D7A5D]" : active ? "text-[#306D29]" : ""}`}>{step.name}</p>
              {step.at && (
                <p className="text-xs text-[#5C5C5C] mt-0.5">
                  {new Date(step.at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
